<template>
  <div class="area">
    <h1>Заголовок h1</h1>
    <h2>Заголовок h2</h2>
    <h3>Заголовок h3</h3>
    <h4>Заголовок h4</h4>
    <h5>Заголовок h5</h5>

    <a
      href="http://hypertexthero.com/work/earth-among-the-stars"
      title="Earth Among The Stars"
    >
      <img
        class="pull-left"
        width="10px"
        src="../assets/icons/location-marker.svg"
      />
    </a>

    <a
      href="http://hypertexthero.com/work/earth-among-the-stars"
      title="Earth Among The Stars"
      class="button"
      >Earth Among The Stars</a
    >
    <p class="text big">
      Text Big: One night when I had tasted bitterness I went out on to the
      hill. Dark heather checked my feet. Below marched the suburban lamps.
    </p>
    <p class="text">
      Text: One night when I had tasted bitterness I went out on to the hill.
      Dark heather checked my feet. Below marched the suburban lamps.
    </p>
    <p class="text small">
      Text Small: One night when I had tasted bitterness I went out on to the
      hill. Dark heather checked my feet
      <a
        href="http://ebooks.adelaide.edu.au/s/stapledon/olaf/star/chapter1.html#chapter1"
        >conscious life</a
      >. Below marched the suburban lamps.
    </p>

    <p class="text mini">
      Text Mini: One night when I had tasted bitterness I went out on to the
      hill. Dark heather checked my feet. Below marched the suburban lamps.
    </p>

    <ul class="nav">
      <li>
        <a href="#">Главная</a>
      </li>
      <li>
        <a href="#">Контакты</a>
      </li>
      <li>
        <a href="#">Меню 3</a>
      </li>
      <li>
        <a class="active" href="#">Меню 4</a>
      </li>
    </ul>

    <ul>
      <li>We had first met when she was a child</li>
      <li>Our eyes encountered</li>
      <li>She looked at me for a moment with quiet attention</li>
      <li>My destiny</li>
    </ul>
    <ul class="checked">
      <li>We had first met when she was a child</li>
      <li>Our eyes encountered</li>
      <li>She looked at me for a moment with quiet attention</li>
      <li>My destiny</li>
    </ul>
    <input
      class="checkbox-input"
      type="checkbox"
      style="display:none"
      id="agree"
      checked="true"
    />
    <label class="checkbox-label" id="form-agreement" for="agree">
      <span>
        Соглашаюсь на
        <a href="#">обработку персональных данных</a>
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: "Typograph"
};
</script>

<style lang="scss"></style>
